import React, { useContext, useState } from 'react';
import { AuthContext, appActions } from '../../context/AuthContext';
import Layout from '../../components/Layout';
import Input from '../../components/form/Input';
import Loading from '../../components/Loading';
import { Auth } from 'aws-amplify';
import { useFormik } from 'formik';
import { Redirect, Link } from 'react-router-dom';
import SEO from '../../components/seo';
import SetupMFA, { getMFAMethodName } from '../../components/auth/SetupMFA';

export const isMFAEnabled = (user) => {
    return user?.preferredMFA && user?.preferredMFA !== 'NOMFA';
};

const AccountIndex = () => {
    const { state, dispatch } = useContext(AuthContext);
    const [setupMFA, setSetupMFA] = useState(false);
    const handleSave = async (values) => {
        try {
            const user = await Auth.currentAuthenticatedUser();
            await Auth.updateUserAttributes(user, values);
            dispatch({
                type: appActions.REFRESH_USER_ATTRS,
                payload: {
                    updatedUserAttributes: (await Auth.currentAuthenticatedUser({ bypassCache: true })).attributes
                }
            });
        } catch (e) {
            console.error(e);
        }
    };

    const { values, errors, touched, handleChange, handleSubmit } = useFormik({
        enableReinitialize: true,
        initialValues: {
            given_name: state.user?.attributes?.given_name ?? '',
            family_name: state.user?.attributes?.family_name ?? ''
        },
        onSubmit: handleSave
    });

    if (!state.user && !state.isLoading) {
        return <Redirect to="/" />;
    }

    const handleMFASuccess = async () => {
        dispatch({
            type: appActions.REFRESH_USER,
            user: await Auth.currentAuthenticatedUser({ bypassCache: true })
        });
        setSetupMFA(false);
    };

    const handleDisableMFA = async () => {
        await Auth.setPreferredMFA(state.user, 'NOMFA');
        await state.user.disableMFA();
        dispatch({
            type: appActions.REFRESH_USER,
            user: await Auth.currentAuthenticatedUser({ bypassCache: true })
        });
    };

    return (
        <Layout>
            {state.isLoading && <Loading />}
            {!state.isLoading && (
                <>
                    <SEO title="My Account" />
                    <h1 className="col-xs-12">My Account</h1>
                    <form onSubmit={handleSubmit} className="mb-6 col-xs-12">
                        <Input
                            className="col-xs-12"
                            id="given_name"
                            label="First Name"
                            value={values.given_name}
                            error={errors.given_name}
                            touched={touched.given_name}
                            onChange={handleChange}
                        />
                        <Input
                            className="col-xs-12"
                            id="family_name"
                            label="Last Name"
                            value={values.family_name}
                            error={errors.family_name}
                            touched={touched.family_name}
                            onChange={handleChange}
                        />
                        <Input
                            className="col-xs-12"
                            id="email"
                            label="Email"
                            defaultValue={state.user?.attributes?.email}
                            disabled
                        />
                        <Input
                            className="col-xs-12"
                            id="username"
                            label="Username"
                            defaultValue={state.user?.username}
                            disabled
                        />
                        <div className="col-xs-12">
                            <button type="submit" className="btn btn-primary mr-2">
                                Save
                            </button>
                            <Link to="/account/change-password">Change Password</Link>
                        </div>
                    </form>
                    <div className="col-xs-12 col-lg-6 middle-md mb-4">
                        <div className="col-xs-12">
                            <h4 className="mb-2">Two-step Verification</h4>
                            {state.user.preferredMFA !== 'NOMFA' && (
                                <button className="btn btn-sm btn-danger col-md-4" onClick={handleDisableMFA}>
                                    Disable
                                </button>
                            )}
                            {(!state.user.preferredMFA || state.user.preferredMFA === 'NOMFA') && (
                                <button className="btn btn-sm btn-secondary col-md-4" onClick={() => setSetupMFA(true)}>
                                    Enable
                                </button>
                            )}
                        </div>
                    </div>
                    {isMFAEnabled(state.user) && (
                    <div className="col-xs-12 col-lg-6 middle-md mb-4">
                        <div className="col-xs-12">
                            <strong>Preferred Method</strong>
                        </div>
                        <div className="col-xs-12">
                            {getMFAMethodName(state.user?.preferredMFA)}{' '}
                            <button className="btn btn-anchor pl-4" onClick={() => setSetupMFA(true)}>
                                Change
                            </button>
                        </div>
                    </div>
                    )}
                    <SetupMFA
                        visible={setupMFA}
                        onCancel={() => setSetupMFA(false)}
                        onSuccess={handleMFASuccess}
                        currentUser={state.user}
                    />
                </>
            )}
        </Layout>
    );
};

export default AccountIndex;
